export interface NativeSmoothDrainStep {
  graphemes: number
  delayMs: number
}

export function segmentNativeGraphemes(text: string): string[] {
  if (typeof Intl !== 'undefined' && 'Segmenter' in Intl) {
    const segmenter = new Intl.Segmenter(undefined, { granularity: 'grapheme' })
    return Array.from(segmenter.segment(text), (part) => part.segment)
  }
  return Array.from(text)
}

export function nativeSmoothDrainStep(backlog: number): NativeSmoothDrainStep {
  if (backlog <= 0) return { graphemes: 0, delayMs: 0 }
  if (backlog <= 6) return { graphemes: 1, delayMs: 28 }
  if (backlog <= 18) return { graphemes: 1, delayMs: 22 }
  if (backlog <= 48) return { graphemes: 2, delayMs: 18 }
  return { graphemes: 3, delayMs: 16 }
}

export function advanceNativeSmoothDrain(displayed: number, target: number): number {
  const backlog = Math.max(0, target - displayed)
  const step = nativeSmoothDrainStep(backlog)
  return Math.min(target, displayed + step.graphemes)
}

export function visibleNativeSmoothCount(displayed: number, target: number, active: boolean): number {
  return active ? Math.min(displayed, target) : target
}
